import {FormChooseExternal} from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemAoName, FormItemAoNo} from '../AO/FormChooseAo.jsx'
import {FormItemAdTitle} from '../AD/FormChooseAd.jsx'

export default function FormChooseAd(props) {
    return (
        <FormChooseExternal {...props}>
            <FormItemAoNo />
            <FormItemAoName />
            <FormItemAdTitle />
        </FormChooseExternal>
    )
}
